import { useEffect, useState } from "react";
import { api } from "@/lib/api";

// Default content used as fallback if backend has no override
export const DEFAULT_CONTENT = {
    hero: {
        badge: "Strategic advisory · Côte d'Azur",
        title: "L'architecture financière",
        titleEmphasis: "des ambitions rares.",
        subtitle:
            "XV Capital Partners accompagne les dirigeants et investisseurs dans la préparation et la structuration d'acquisitions, de financements et de partenariats stratégiques en France et à l'international. Nous coordonnons les expertises juridiques, fiscales et financières adaptées à chaque opération et mobilisons les partenaires pertinents.",
        cta1: "Premier entretien",
        cta2: "Notre approche",
    },
    stats: {
        kicker: "Sélectivité · Discrétion · Vision long terme",
        items: [
            { value: 8, suffix: "", label: "Places financières internationales" },
            { value: 4, suffix: "", label: "Continents couverts par le réseau" },
            { value: 20, suffix: " ans+", label: "Expérience terrain" },
        ],
    },
    cities: {
        list: [
            "Côte d'Azur",
            "Genève",
            "Londres",
            "Miami",
            "Tokyo",
            "Pékin",
            "Dubaï",
            "Doha",
        ],
    },
    contact: {
        email: "contact@xv-capitalpartners.com",
        kicker: "Premier entretien · Confidentiel",
        intro:
            "Chaque mission s'ouvre par un entretien confidentiel d'évaluation. Décrivez-nous brièvement votre projet ; nous reprenons contact sous 48 heures ouvrées.",
    },
    manifesto: {
        kicker: "Manifeste · Cabinet indépendant",
        line1: "Les opérations qui marquent",
        line2: "ne se traitent ni seul,",
        line3: "ni en série.",
    },
    about_founder: {
        kicker: "Le fondateur",
        title: "Joel Kotho",
        role: "Fondateur & Managing Partner",
        intro:
            "Entrepreneur, fondateur de XV Capital Partners et ancien international de rugby, Joel Kotho accompagne dirigeants, investisseurs et familles entrepreneuriales dans leurs projets de croissance, de structuration et de développement international.",
    },
    footer: {
        tagline: "Cabinet indépendant de strategic advisory et d'architecture financière — à la croisée du développement d'entreprise et des réseaux internationaux d'experts.",
        signature: "Strategic advisory · Architecture financière",
    },
};

export function useContent() {
    const [content, setContent] = useState(DEFAULT_CONTENT);

    useEffect(() => {
        let cancelled = false;
        api.get("/content")
            .then(({ data }) => {
                if (cancelled || !data) return;
                // Merge backend over defaults, deep on first level
                const merged = { ...DEFAULT_CONTENT };
                for (const [k, v] of Object.entries(data)) {
                    merged[k] = { ...(DEFAULT_CONTENT[k] || {}), ...v };
                }
                setContent(merged);
            })
            .catch(() => {
                /* keep defaults */
            });
        return () => {
            cancelled = true;
        };
    }, []);

    return content;
}
